export interface Message {
  id: number;
  message: string;
}

export class Loader {
  private _messages: Message[] = [];
  private _cptId = 0;

  /**
   * @param message - loading message to add
   * @returns function that removes the loading message
   */
  public addMessage(message: string): () => void {
    let stopped = false;
    const id = this._cptId++;

    this._messages.unshift({ id, message });

    return () => {
      if (!stopped) {
        // Only remove the message once
        stopped = true;

        const idx = this._messages.findIndex(m => m.id === id);
        if (idx !== -1) {
          this._messages.splice(idx, 1);
        }
      } else if (process.env.NODE_ENV !== 'production') {
        console.warn(
          'Detected multiple calls to a single "removeMessage" callback. A single start can only be stopped once.'
        );
      }
    };
  }

  /**
   * Clears all the messages
   */
  public clearAll() {
    this._messages = [];
  }

  /**
   * @returns the current messages
   */
  public get messages(): Message[] {
    return [...this._messages];
  }
}
